/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpfbreq33Inputs */

const en_crosspostinghelpfbreq33 = /** @type {(inputs: Crosspostinghelpfbreq33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in with the profile that manages the Page, and in the Meta dialog select the Page and keep every permission switched on.`)
};

const de_crosspostinghelpfbreq33 = /** @type {(inputs: Crosspostinghelpfbreq33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich mit dem Profil an, das die Seite verwaltet, und wähle im Meta-Dialog die Seite aus – lass dabei alle Berechtigungen aktiviert.`)
};

/**
* | output |
* | --- |
* | "Log in with the profile that manages the Page, and in the Meta dialog select the Page and keep every permission switched on." |
*
* @param {Crosspostinghelpfbreq33Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpfbreq33 = /** @type {((inputs?: Crosspostinghelpfbreq33Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpfbreq33Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpfbreq33(inputs)
	return de_crosspostinghelpfbreq33(inputs)
});
export { crosspostinghelpfbreq33 as "crosspostingHelpFbReq3" }